"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _formik = require("formik");
var FieldParts = _interopRequireWildcard(require("../Inputs/FieldParts"));
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _Toggle = _interopRequireDefault(require("../Inputs/Toggle"));
var _helpers = require("../helpers");
var _excluded = ["name", "label", "labelPosition", "readerLabel", "children", "colorOn", "info", "disabled", "automationHook", "onFormikChange", "mB", "marginBottom"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Name of the field */
  name: _propTypes["default"].string.isRequired,
  /** Label of the field */
  label: _propTypes["default"].string,
  /** This will determine the label placement next to the toggle. The default value is `leftSpaced` which positions the label on the left side and spaces the label and toggle to occupy the whole width alloted to the field.  */
  labelPosition: _propTypes["default"].oneOf(["leftSpaced", "rightSpaced", "left", "right"]),
  /** Label that is invisible, but will be available as screen reader text. Required if label is missing. */
  readerLabel: _propTypes["default"].string,
  /** Will be rendered instead of label. If you have something custom that needs to go in there */
  children: _propTypes["default"].node,
  /** Flag to disabled the field */
  disabled: _propTypes["default"].bool,
  /** Color of toggle background when checked. Default set to "success" */
  colorOn: _propTypes["default"].string,
  /** Set bottom margin for the field */
  mB: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  /** Description that appears under the field, explaining what it does */
  info: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string,
  /** Extra function to call after the formik field is changed. Receives an object with value and event. */
  onFormikChange: _propTypes["default"].func,
  /** DEPRECATED: Margin bottom for the field wrapper */
  marginBottom: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string])
  /** + Other Toggle propTypes */
};
var getPositioningProps = function getPositioningProps(labelPosition) {
  switch (labelPosition) {
    case "left":
      return {
        justifyContent: "flex-start"
      };
    case "right":
      return {
        justifyContent: "flex-end",
        direction: "row-reverse"
      };
    case "rightSpaced":
      return {
        justifyContent: "space-between",
        direction: "row-reverse"
      };
    case "leftSpaced":
    default:
      return {
        justifyContent: "space-between"
      };
  }
};
var ToggleFormik = function ToggleFormik(_ref) {
  var name = _ref.name,
    label = _ref.label,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? "leftSpaced" : _ref$labelPosition,
    readerLabel = _ref.readerLabel,
    children = _ref.children,
    _ref$colorOn = _ref.colorOn,
    colorOn = _ref$colorOn === void 0 ? "success" : _ref$colorOn,
    info = _ref.info,
    disabled = _ref.disabled,
    automationHook = _ref.automationHook,
    onFormikChange = _ref.onFormikChange,
    mB = _ref.mB,
    marginBottom = _ref.marginBottom,
    rest = _objectWithoutProperties(_ref, _excluded);
  (0, _helpers.useDeprecate)({
    marginBottom: marginBottom
  }, "ToggleFormik");
  var _useField = (0, _formik.useField)(name),
    _useField2 = _slicedToArray(_useField, 2),
    field = _useField2[0],
    meta = _useField2[1];
  var hasError = meta.error && meta.touched;
  var changeHandler = function changeHandler(e) {
    field.onChange(e);
    onFormikChange === null || onFormikChange === void 0 ? void 0 : onFormikChange({
      value: e.target.checked,
      event: e
    });
  };
  return /*#__PURE__*/_react["default"].createElement(FieldParts.Wrapper, {
    mB: mB !== null && mB !== void 0 ? mB : marginBottom
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], _extends({
    d: "flex",
    gap: "xs",
    alignItems: "center"
  }, getPositioningProps(labelPosition)), children || label && /*#__PURE__*/_react["default"].createElement(FieldParts.Label, _extends({
    disabled: disabled,
    hasError: hasError
  }, (0, _automationHooks.hook)(automationHook, "field-label")), label), /*#__PURE__*/_react["default"].createElement(_Toggle["default"], _extends({}, field, {
    onChange: changeHandler,
    id: name,
    name: name,
    checked: !!field.value,
    colorOn: colorOn,
    disabled: disabled,
    readerLabel: readerLabel || label,
    automationHook: automationHook
  }, rest))), info && /*#__PURE__*/_react["default"].createElement(FieldParts.Info, (0, _automationHooks.hook)(automationHook, "field-info"), (0, _isFunction["default"])(info) ? info() : info), hasError && /*#__PURE__*/_react["default"].createElement(FieldParts.Error, (0, _automationHooks.hook)(automationHook, "field-error"), meta.error));
};
ToggleFormik.propTypes = propTypes;
ToggleFormik.displayName = "ToggleFormik";
var _default = exports["default"] = ToggleFormik;